import { useMemo } from "react";
import calcDifference from "@arelia-utils/helpers/calcDifference";
import { ComponentProps } from "@arelia-types/widget";
import CustomersPresenter from "./CustomersPresenter";
import { useQuery } from "react-query";
import { http } from "src/api/http";

type Stats = {
  totalCustomers: number;
  totalCustomersLastQ: number;
}

export default function CustomersContainer({ config }: ComponentProps) {
  const { data, isLoading } = useQuery<Stats>({
    queryKey: ["useHqCustomersStats"],
    queryFn: () => http(`/api/hq/customers/stats`)
  });

  const changes = useMemo(() => calcDifference(data?.totalCustomers || 0, data?.totalCustomersLastQ || 0), [data]);

  return (
    <CustomersPresenter
      total={data?.totalCustomers}
      changes={changes}
      loading={isLoading}
      widgetConfig={config}
    />
  );
}
